<template>
<div class="content2">
  <div>
<!--    v-if="ERP.isPermission(8007001001)"-->
<!--    <el-button @click="exportExcel" >导出诉讼计划</el-button>-->
<!--    v-if="ERP.isPermission(8007001002)"-->
<!--    <el-button @click="importLegalPlanExcel" >导入诉讼调整</el-button>-->

    <el-date-picker
      style="width: 150px"
      v-model="where.yaer_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="计划月份">
    </el-date-picker>
    <el-button size="mini" type="primary" @click="initUrgeType(2)">校准项目诉讼计划</el-button>
    <el-button size="mini" type="primary" @click="initUrgeType(4)">校准第三方诉讼计划</el-button>
  </div>
  <div class="header-tip">
    <div class="header-tip-body">
<!--      <div class="header-tip-body-item">-->
<!--        <div class="header-tip-body-item-title">-->
<!--          <div>未导入项目数：</div>-->
<!--          <div>已导入项目数：</div>-->
<!--        </div>-->
<!--        <div class="header-tip-body-item-val">-->
<!--          <div>{{pageData.total}}</div>-->
<!--          <div>{{pageData.total}}</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="header-tip-body-item">
        <div class="header-tip-body-item-title">
          <div>本月计划&nbsp;&nbsp;-&nbsp;&nbsp;</div>
          <div>本月计划&nbsp;&nbsp;-&nbsp;&nbsp;</div>
        </div>
        <div class="header-tip-body-item-val">
          <div>户数：{{formatMoney((count_obj||{}).original_plan_count)}}</div>
          <div>金额：{{formatMoney((count_obj||{}).original_plan_amount||0,2)}}</div>
        </div>
      </div>
      <div class="header-tip-body-item">
        <div class="header-tip-body-item-title">
          <div>计划调整&nbsp;&nbsp;-&nbsp;&nbsp;</div>
          <div>计划调整&nbsp;&nbsp;-&nbsp;&nbsp;</div>
        </div>
        <div class="header-tip-body-item-val">
          <div>户数：{{formatMoney((count_obj||{}).adjust_count)}}</div>
          <div>金额：{{formatMoney((count_obj||{}).adjust_amount||0,2)}}</div>
        </div>
      </div>
      <div class="header-tip-body-item">
        <div class="header-tip-body-item-title">
          <div>实际计划&nbsp;&nbsp;-&nbsp;&nbsp;</div>
          <div>实际计划&nbsp;&nbsp;-&nbsp;&nbsp;</div>
        </div>
        <div class="header-tip-body-item-val">
          <div>户数：{{formatMoney((count_obj||{}).current_plan_count)}}</div>
          <div>金额：{{formatMoney((count_obj||{}).current_plan_amount||0)}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="table-wrap">
    <el-table
      v-loading="loading" :data="pageData.list"
      border
      style="width: 100%" height="50vh">
      <el-table-column
        prop="name"
        label="名称"
        width="200">
      </el-table-column>
      <el-table-column
        prop="year_month"
        label="年月"
        width="100" align="center">
      </el-table-column>
      <el-table-column
        label="户数" align="center">
        <el-table-column
          prop="original_plan_count"
          label="本月计划" align="center" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="openLog(scope.row,2)">{{scope.row.original_plan_count}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="adjust_count"
          label="计划调整" align="center" width="100">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="current_plan_count"-->
<!--          label="实际计划" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-link type="primary" @click="openLog(scope.row,1)">{{scope.row.current_plan_count}}</el-link>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          prop="current_plan_count"
          label="实际计划" align="center">
          <el-table-column
            prop="current_plan_ss_count"
            label="诉讼" align="center" width="100">

          </el-table-column>
          <el-table-column
            prop="current_plan_dsfss_count"
            label="第三方诉讼" align="center" width="100">

          </el-table-column>
          <el-table-column
            prop="current_plan_dsfgl_count"
            label="第三方管理" align="center" width="100">

          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="金额" align="center">
        <el-table-column
          prop="original_plan_amount"
          label="本月计划" align="center" :formatter="milFormatter" width="100">
        </el-table-column>
        <el-table-column
          prop="adjust_amount"
          label="计划调整" align="center" :formatter="milFormatter" width="100">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="current_plan_amount"-->
<!--          label="实际计划" align="center"></el-table-column>-->
<!--        </el-table-column>-->
        <el-table-column
          prop="current_plan_amount"
          label="实际计划" align="center">
          <el-table-column
            prop="current_plan_ss_amount"
            label="诉讼" align="center" :formatter="milFormatter" width="100">

          </el-table-column>
          <el-table-column
            prop="current_plan_dsfss_amount"
            label="第三方诉讼" align="center" :formatter="milFormatter" width="100">

          </el-table-column>
          <el-table-column
            prop="current_plan_dsfgl_amount"
            label="第三方管理" align="center" :formatter="milFormatter" width="100">

          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间" width="150" align="center">
      </el-table-column>
      <el-table-column
        prop="updated_at_text"
        label="修改时间" width="150" align="center">
      </el-table-column>
    </el-table>

  </div>
<!--  <div class="pagination-wrap">-->
<!--    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"-->
<!--                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"-->
<!--                   @current-change="pageChange"></el-pagination>-->
<!--  </div>-->

  <el-dialog
    :visible.sync="dialogVisible"
    width="400px">
    <div>
      <el-descriptions :column="1">
        <el-descriptions-item label="开始时间">
          <el-date-picker
            v-model="form_data.start_time"
            type="month"
            size="mini"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="结束时间">
          <el-date-picker
            v-model="form_data.end_time"
            type="month"
            size="mini"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <template #footer>
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button @click="exportExcel">导出</el-button>
    </template>
  </el-dialog>

  <HouseUrgeLockHistoryDialog ref="houseUrgeLockHistoryDialogRef" />
  <ConfirmDialog ref="ConfirmDialogRef" />
</div>
</template>

<script>
import moment from "moment/moment";
import Http from "../../common/Http";
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import HouseUrgeLockHistoryDialog from "./HouseUrgeLockHistoryDialog";
import ConfirmDialog from "../common/ConfirmDialog";

export default {
  name: "ExpeditingFeesPlanYearMonth",
  components: {ConfirmDialog, HouseUrgeLockHistoryDialog},
  inject:['where','reginWhere'],
  data(){
    return{
      loading: false,
      where:{
        yaer_month: moment(new Date()).format("YYYY-MM"),
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      count_obj:{},
      dialogVisible:false,
      form_data:{
        start_time: moment(new Date()).format("YYYY-MM"),
        end_time: moment(new Date()).format("YYYY-12")
      }
    }
  },
  mounted() {
    const that=this;
    that.pageChange(1);
  },
  methods:{
    searchList(){
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      };
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      where.level=that.reginWhere.level;

      ButlerHttp.post("ProjectCollectionProceedingPlanAdjust/getGroupLevelList",{
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      },res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
      this.getProjectCollectionPlanCountObj()
    },
    getProjectCollectionPlanCountObj(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.post("ProjectCollectionProceedingPlanAdjust/getAdjustCountObj",{
        ...where
      },res => {
        if (res.code) {
          that.count_obj = res.data
        }
      })
    },
    exportExcel(){
      const that=this;

      that.dialogVisible=false;

      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        start_time:that.form_data.start_time,
        end_time:that.form_data.end_time,
      }
      ButlerHttp.post("ProjectCollectionProceedingPlanAdjust/exportExcel",{
        ...where,
      },res => {
        loading.close()
        if (res.code) {
          window.open(res.data)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    importLegalPlanExcel(){
      const that=this;
      ButlerHttp.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("ProjectCollectionProceedingPlanAdjust/importExcelFlow",{
          file:file,
        },res => {
          loading.close()
          if (res.code) {
            let timeStr=(new Date()).getTime()
            ERP.navigateTo(`/flow/FlowView?sheet_id=174&master_id=141&timeValue=${timeStr}&batch_number=${res.data}`)
            // that.pageChange(1);
          }else {
            that.$message.error(res.msg);
          }
        })
      })
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    },
    openLog(row,type=1){
      const that=this;
      if(type==1){
        that.$refs.houseUrgeLockHistoryDialogRef.show({
          url:"HouseUrgeLockHistory/index",
          project_ids:row.project_ids,
          year_month:that.where.yaer_month,
          urge_types:'诉讼,第三方诉讼,项目诉讼'
        });
      }else {
        that.$refs.houseUrgeLockHistoryDialogRef.show({
          url:"ProjectCollectionProceedingPlanHouse/index2",
          project_ids:row.project_ids,
          year_month:that.where.yaer_month,
          urge_types:'诉讼,第三方诉讼,项目诉讼'
        });
      }

    },
    initUrgeType(urge_type){
      const that=this;
      if(!that.reginWhere.project_ids&&!that.reginWhere.project_name){
        that.$message.error("请选择项目");
        return false;
      }
      if(!that.where.yaer_month){
        that.$message.error("请选择月份");
        return false;
      }
      that.$refs.ConfirmDialogRef.show({
        title: '计划校准提示',
        content: `
        <div style="font-size: 18px;line-height: 1.5;color:#000000;width: 100%;">
<p>1.校准计划是相对的，因为欠费金额、欠费房产等都会随时间变化而变化。每次触发，计数都会减小。</p>
<p>2.校准是基于已经做了计划的房产进行的重新统计计数，如果异常请查看【催缴房产】的明细统计。</p>
<p>3.校准是存在计数风险的，因为月初计数和月末计数可能存在偏差，请谨慎操作。</p>
</div>
        `,
        delayTimer:2,
        confirmFn: () => {
          that.loading = true;
          ButlerHttp.post("HouseUrge/initUrgeType",{
            project_ids:that.reginWhere.project_ids,
            project_id:that.reginWhere.project_name,
            year_month:that.where.yaer_month,
            urge_type:urge_type
          },res => {
            that.loading = false;
            if (res.code) {
              that.getList();
              that.$message.success("初始化成功");
            }else {
              that.$message.error(res.msg||'初始化异常');
            }
          });
        },
        cancelFn: () => {
          that.$message.error("取消操作");
        }
      });
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where.yaer_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
        &:first-child {
          margin-left: 8px;
        }
      }

    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ExpeditingFeesPlanYearMonth.vue